import { setRangeMax } from './helpers';

export const setRoomsForSaleMax = setRangeMax('rooms_for_sale');
